import * as React from 'react';

import { uniqueIdFactory } from '../../../../../api/quiz/getQuizzes/normalize/uniqueIds';

interface TrashQuizActions {
  restoreQuiz: (uniqueId: string) => void;
  purgeQuiz: (uniqueId: string) => void;
}

const TrashQuizActionContext = React.createContext<TrashQuizActions>(undefined);

export interface TrashQuizActionProviderProps {
  children: React.ReactNode;
  onRestoreQuiz: (QuizId: number) => void;
  onPurgeQuiz: (QuizId: string) => void;
}

export function TrashQuizActionProvider({
  children,
  onRestoreQuiz,
  onPurgeQuiz,
}: TrashQuizActionProviderProps) {
  const QuizActions = React.useMemo(
    () => ({
      restoreQuiz: (uniqueId: string) => {
        onRestoreQuiz(uniqueIdFactory.quiz.toEntityId(uniqueId));
      },
      purgeQuiz: (uniqueId: string) => {
        onPurgeQuiz(uniqueId);
      },
    }),
    [onRestoreQuiz, onPurgeQuiz]
  );

  return (
    <TrashQuizActionContext.Provider value={QuizActions}>
      {children}
    </TrashQuizActionContext.Provider>
  );
}

export function useTrashQuizActions() {
  const context = React.useContext(TrashQuizActionContext);

  if (context === undefined) {
    throw new Error(
      'useTrashQuizActions must be used within TrashQuizActionContext'
    );
  }

  return context;
}
